import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assests/imgs/Logos/Logos/Cream Primary Logo.png';
import navIcon from '../assests/imgs/IMG_7397.PNG';
import navBrickIcon from '../assests/imgs/navbrick.png'; // Add the new icon

export default function Masthead() {
  const [isNavVisible, setIsNavVisible] = React.useState(false); // State to track visibility of nav-links
  const [isSpinning, setIsSpinning] = React.useState(false);   // State to track spinning animation
  const [spinDirection, setSpinDirection] = React.useState('spin'); // Track spin direction ('spin' or 'spin-back')
  
  const location = useLocation(); // Hook to track location changes

  // Effect to scroll to the top when the route changes
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top of the page
  }, [location]); // Dependency on location changes (route changes)

  const toggleNav = () => {
    const newDirection = isNavVisible ? 'spin-back' : 'spin';

    setIsSpinning(true);
    setSpinDirection(newDirection);

    setTimeout(() => {
      setIsNavVisible(!isNavVisible);
      setIsSpinning(false);
    }, 500); // Match the duration of the spin animation
  };

  const closeNav = () => {
    setIsNavVisible(false);
    setSpinDirection('spin-back');

    setTimeout(() => {
      setIsSpinning(false);
    }, 500);
  };

  return (
    <header className="masthead">
      <div className="logo">
      <Link className="" to="/" onClick={closeNav}>
        <img src={logo} alt="Logo" />
        </Link>
      </div>
      <nav className="main-nav">
        <div className="nav-icon pr-1">
          <button
            className="p-0 m-0 btn-0 btn"
            type="button"
            onClick={toggleNav}
          >
            {isNavVisible ? (
            <img
              src={ navBrickIcon }
              alt="n-icon"
              className={isSpinning ? spinDirection : ''}
            />):(
            <img
              src={ navIcon}
              alt="n-icon"
              className={isSpinning ? spinDirection : ''}
            />)}
          </button>
        </div>
        <ul className={`nav-links ${isNavVisible ? 'show' : 'hide'}`}>
          <li><Link className="nav-link" to="/" onClick={closeNav}>Home</Link></li>
          <li><Link className="nav-link" to="/about" onClick={closeNav}>About Us</Link></li>
          <li><Link className="nav-link" to="/projects" onClick={closeNav}>Projects</Link></li>
          <li><Link className="nav-link" to="/contact" onClick={closeNav}>Contact Us</Link></li>
        </ul>
      </nav>
    </header>
  );
}
